import React from 'react';
import './index.css';
const Avatar = (props) => {
    let src = "";
    if (props.fullPath) {
        src = props.image
    } else {
        src = props.image &&  require(`../../../assets/images/${props.image}`).default   
     }
    return (
        <img
        {...props}
            src={src}
            // src={`${props.image}`}
            className={`img-fluid ${props.class}`}
            alt={props.alt}
            style={{ ...props.style }}
        />
    );
};
export default Avatar

